module.exports = __webpack_public_path__ + "img/23.d28f8528.jpg";